import {setSmoother,gsap, ScrollSmoother, ScrollTrigger, SplitText, forceScrollSmootherUpdate, smoother, Flip, scrollPosition} from "./gsap";
import {documentReady, observeElementResize, scrollToEl } from "./utils";
import Dom from '../utility/dom';

// const body = document.querySelector('body');
const body = Dom.body;
let scrollTop = smoother ? smoother.scrollTop() : 0;
window.addEventListener('resize',()=>{
    scrollTop = smoother ? smoother.scrollTop() : 0;
});

const InitializeSmoothing = () => {
    gsap.registerPlugin(ScrollTrigger);

    if(!!body.querySelector('.scroll-smoother-wrapper')){
        // Register GSAP Plugins (comma separated) including:
        // ScrollTrigger, ScrollSmoother, SplitText, and Flip.
        gsap.registerPlugin(ScrollSmoother);
    
        ScrollTrigger.config({ 
            ignoreMobileResize: true,
            refreshPriority: 9,
        })
        
        documentReady(()=>{
            observeElementResize(document.querySelector('#page'), ()=>{
                if(body.classList.contains('prevent-smoother-update')) return;

                forceScrollSmootherUpdate(); 
            });

            // If the page lands on a url with an anchor, update smooth scroll to
            // that position
            const hash = window.location.hash;
            const target = hash ? document.querySelector(hash) : null;
            if(!!target){
                setTimeout(()=> {
                    if(smoother){
                        ScrollSmoother.get().scrollTo(target, true, "top 50px");
                    }
                    else {
                        scrollToEl(target);
                    }
                }, 1000);
            }

        })
        
        //no scrollsmoother on mobile - too glitchy on ios
        if (!ScrollTrigger.isTouch) {
            body.classList.add('smoothscroll');

            setSmoother(ScrollSmoother.create({
                wrapper: ".scroll-smoother-wrapper",
                content: ".site",
                smooth: 0.4,
                ease:"power4.out",
                effects: true,
                ignoreMobileResize: true,
                normalizeScroll: true,
                smoothTouch: 0.1,
            }));

            // This ensure's overflow:scroll works for nested content.
            ScrollTrigger.normalizeScroll({
                allowNestedScroll: true
            });
        }
    }
}

export const watchAnimations = () => {
    const els = document.querySelectorAll('[class*="td_animation"]');
    
    if(els){
        els.forEach(el => {
            setAnimationScrollTrigger(el);
        });
    }
}


export const setAnimationScrollTrigger = (el) =>{
    if(!el.classList.contains('animated') && el.animationSet == undefined){
        el.animationSet = true;
        const anim = ScrollTrigger.create({
            trigger: el,
            start: "top bottom",
            end: "bottom top",
            onEnter: () => {
                // Media
                el.classList.add('animated');
                setTimeout(() => {
                    anim.kill(false);
                }, 2000);
            }
        });
    }
}

const InitializeSmoothAnchorLinks = () => {

    document.querySelectorAll("a[href^='#']").forEach((a) => {

        const linkHandler = (e) => {
            e.preventDefault();
            if(a.hash){
                if('preventDefault' in a.dataset) return;
                
                const target = document.querySelector(a.hash);
                if(!!target && !Dom.prefersReducedMotion){
                    const targetPos = smoother ? smoother.offset(target, "top top") : target.getBoundingClientRect().top;
    
                    if(smoother){
                        smoother.scrollTo(target, true, "top 50px");
                    }
                    else {
                        scrollToEl(target);
                    }
    
                    // Hide the header for better landing.
                    const header = document.querySelector('#masthead');
                    header.classList.add('hide-while-scrolling');
                    setTimeout(()=>{
                        header.classList.add('hide-header');
                        header.classList.remove('hide-while-scrolling');
                    }, 1100);
                }
            }
        };

        a.addEventListener("click", linkHandler);
    });
}


const IntializeHeaderState = () => {
    const header = document.querySelector('#masthead');

    ScrollTrigger.create({
        trigger: body,
        start: "top top",
        onUpdate: self => {
            if(body.classList.contains('prevent-smoother-update')) return;

            const hiddenClass = 'hide-header';
            const scrolledClass = 'header-scrolled';
            
            // Always show header above 400px scroll position
            if(scrollPosition() < 400) {
                if(header.classList.contains(hiddenClass)){
                    header.classList.remove(hiddenClass);
                }
                if(body.classList.contains(scrolledClass)){
                    body.classList.remove(scrolledClass);
                }
            }
            else if(scrollPosition() >= 400) {
                if(!body.classList.contains(scrolledClass)){
                    body.classList.add(scrolledClass)
                }

                if(self.direction == -1 
                && header.classList.contains(hiddenClass)
                && !body.classList.contains('preventHeaderReveal')){
                    header.classList.remove(hiddenClass);
                }
                else if(self.direction == 1 
                && !header.classList.contains(hiddenClass)
                && !body.classList.contains('preventHeaderHide')){
                    header.classList.add(hiddenClass);
                }
            }
        }
    });
}


const InitializeGSAPOnPageLoad = () => {

    InitializeSmoothing();
    InitializeSmoothAnchorLinks();
    IntializeHeaderState();

    forceScrollSmootherUpdate();


    window.addEventListener("load", (e) => {
        // Anchor links don't smooth scroll until the page has 
        // been scrolled so we'll move the page 1px on load.
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        scroll({
            top: currentScroll+1,
            behavior: "smooth",
        });
        
        if (window.location.hash && smoother) {
            ScrollSmoother.get().scrollTo(window.location.hash, true);
        }
    });

}

export { gsap, InitializeGSAPOnPageLoad }
